"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dashboard = void 0;
class Dashboard {
    constructor() {
        this.name = undefined;
        this.currentValue = 0.0;
        this.totalReturnValue = 0.0;
        this.inceptionDate = undefined;
        this.valueOverTimeList = [];
        this.portfolios = [];
        this.adviser = undefined;
    }
}
exports.Dashboard = Dashboard;
